import { useCallback } from 'react';
import useLocale from '../Utilities/useLocale';

export const useNumberUtils = () => {

    const localeCode: string | undefined = useLocale();

    const formatLongNumber = useCallback((number) => {
        if (number == null) {
            return null;
        }

        if (localeCode) {
            return number.toLocaleString(localeCode);
        } else {
            return number;
        }
    }, [localeCode]);

    return { formatLongNumber };
}